import { toast } from 'material-react-toastify';

import Button from '@/components/shared/Button/Button';
import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';

interface AuthMagicLinkProps {
  userId: string;
}

export const AuthMagicLink = ({ userId }: AuthMagicLinkProps) => {
  const handleSendMagicLink = async () => {
    const token = await getAuthToken();
    try {
      const { data } = await hubApi.createAuthTokenHub(userId, withAuthHeader(token));
      navigator.clipboard.writeText(data.magicLink);
      toast.info(`Magic link sent to user's email and copied to clipboard`);
    } catch (error) {
      console.error('Error sending magic link:', error);
      toast.error('Error sending magic link');
    }
  };

  return (
    <Button
      onClick={handleSendMagicLink}
      label="Send Magic Link"
      variant="transparent"
      size="s"
      className="font-semibold"
    />
  );
};
